import React from "react";
import {
  AlertContext,
  DialogContext,
  BackdropContext,
  DrawerContext,
  ProjectInfoContext,
} from "../contexts";

const withAllContexts = (Component) => (props) => {
  const alert = React.useContext(AlertContext);
  const dialog = React.useContext(DialogContext);
  const backDrop = React.useContext(BackdropContext);
  const drawer = React.useContext(DrawerContext);
  const projectinfo = React.useContext(ProjectInfoContext);

  return (
    <Component
      {...props}
      alert={alert}
      dialog={dialog}
      backDrop={backDrop}
      drawer={drawer}
      projectinfo={projectinfo}
    >
      {props.children}
    </Component>
  );
};

export default withAllContexts;
